<template>
  <section class="virtual-help-desk">
    <div v-if="checkToken && lang && lang['virtual_helpdesk_new'] && airline" class="virtual-helpdesk h-100">
      <div v-if="step == 'search' && isBeginPage">
        <ItemOfVouchers
          :is-pointer="false"
          icon="contact-detail"
          color="#a7116f"
          :label="lang['virtual_helpdesk_new'].SFS_LANG_ROW_27 || 'Contact details'"
          border
        />
      </div>
      <div v-else @click="goHome()">
        <ItemOfVouchers
          icon="contact-detail"
          color="#a7116f"
          :label="lang['virtual_helpdesk_new'].SFS_LANG_ROW_27 || 'Contact details'"
          border
        />
      </div>
      <div class="container vh-container">
        <div class="page-virtual-helpdesk vhd-content">
          <div v-if="step === 'search'">
            <div v-show="!showPRNOrDetailSearch" class="ws-textbox vhd-container">
              <div class="form-group text-center">
                <!-- SFS_LANG_ROW_1: Check your details so <airline> can contact you. -->
                <p v-html="replaceStr(lang['virtual_helpdesk_new'].SFS_LANG_ROW_1, ['<airline>'], [airline.name])"></p>
              </div>
              <div v-if="airline && airline.params && !!parseInt(airline.params.enable_scan_boarding_pass)" class="form-group">
                <div class="text-center">
                  <div>
                    <span class="span-scan">{{ lang['virtual_helpdesk_new'].SFS_LANG_ROW_28 || 'Scan your boarding pass' }}</span>
                  </div>
                  <button type="button" class="ws-btn btn-primary hd-normal-btn-color mt-3" @click="openCameraToScan()">
                    <i class="fa fa-camera fs-scan" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <br />
              <br />
              <br />
              <div class="form-group">
                <div class="row">
                  <div class="col-12 text-center text-120">
                    <button type="button" class="btn ws-btn h-100 p-2 reference" @click="actionEnterVitural('PASSENGER_INFO')">
                      <span
                        class="booking-reference"
                        v-html="
                          lang['virtual_helpdesk_new'].SFS_LANG_ROW_31 || 'Enter <br /> booking reference <br /> and last name'
                        "
                      ></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="showPRNOrDetailSearch">
              <Search
                :open-popup-select-flight="openPopupSelectFlight"
                :not-found-name="notFoundName"
                :not-found-pnr="notFoundPnr"
                :list-flight="listFlight"
                :step="step"
                :type="type"
                @updateStep="updateStep"
                @updateFlightInfo="updateFlightInfo"
                @setDataSearchPax="setDataSearchPax"
                @searchListFlight="searchListFlight"
                @updateOpenPopupSelectFlight="updateOpenPopupSelectFlight"
              />
            </div>
            <b-modal
              id="modal-popup-open-camera"
              :modal-class="'ws-modal'"
              centered
              hide-footer
              hide-header
              no-close-on-backdrop
              class="border-0"
              size="lg"
              title=""
            >
              <div id="reader" width="600px"></div>
              <div class="mt-3 text-center">
                <button
                  type="button"
                  class="ws-btn hd-normal-btn-background-color hd-normal-btn-color"
                  @click="closeOrStopScanBoarding()"
                >
                  <i class="fas fa-times"></i>
                  Close scan
                </button>
              </div>
            </b-modal>
          </div>
          <div v-if="step === 'this_is_me'">
            <ConfirmThisIsMe
              :data-pax="dataPax"
              :pax-this-is-me="paxThisIsMe"
              :flightinfo="flightinfo"
              @updateStep="updateStep"
              @setThisIsMe="setThisIsMe"
              @updateDataSearchPax="updateDataSearchPax"
              @updateListDataPax="updateListDataPax"
              @updateListFlight="updateListFlight"
              @updateFlightInfo="updateFlightInfo"
              @searchPassenger="searchPassenger"
            />
          </div>
          <div v-if="step === 'confirm'">
            <Confirm :token="token" :pax-this-is-me="paxThisIsMe" :flight="flightinfo" />
          </div>
        </div>
      </div>
      <b-alert
        v-model="showAlertError"
        class="position-fixed fixed-top m-0 rounded-0"
        style="z-index: 2000; border-radius: 1rem !important; border: 1px solid #ffa5a5; color: #444"
        variant="danger"
        dismissible
      >
        <div>
          <div v-for="(error, index) in messagesError" :key="index">
            <div>{{ error }}</div>
          </div>
        </div>
      </b-alert>
    </div>
    <div v-if="!checkToken" class="virtual-helpdesk">
      <div class="container">
        <h4 style="color: red">Invalid Token</h4>
      </div>
    </div>
  </section>
</template>

<script>
import '@/assets/scss/modules/VirtualHelpdesk.scss'
import Search from '@/views/VirtualHelpdesk/contactSearch'
import Confirm from '@/views/VirtualHelpdesk/contactConfirm'
import ConfirmThisIsMe from '@/views/VirtualHelpdesk/contactConfirmThisIsMe'
import ItemOfVouchers from '@/components/ItemOfVouchers/index'
import { Html5Qrcode } from 'html5-qrcode'
import '@/assets/scss/modules/PaxContactConfirm.scss'

export default {
  name: 'VirtualHelpdesk',
  components: { Search, Confirm, ItemOfVouchers, ConfirmThisIsMe },
  props: {
    token: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      notFoundName: false,
      notFoundPnr: false,
      openPopupSelectFlight: false,
      step: 'search',
      checkToken: true,
      lang_code: 'en',
      dataSearchPax: null,
      codeQrReaded: '',
      TYPE_VITURAL_HELP_DESK: {
        BOOKING_REF: 1,
        PASSENGER_DETAIL: 2
      },
      type: 1,
      showPRNOrDetailSearch: false,
      paxThisIsMe: {},
      dataPax: [],
      messagesError: [],
      showAlertError: false,
      flightinfo: null,
      listFlight: [],
      isBeginPage: true
    }
  },
  watch: {
    airline: {
      handler(val) {
        if (this.$cookie.get('selected_lang_' + this.airline.id)) {
          this.lang_code = this.$cookie.get('selected_lang_' + this.airline.id)
        }
        this.$store.dispatch('VirtualHelpdesk/getLanguagesByAirlineToken', {
          airline_token: this.$route.query.token,
          lang_code: this.lang_code
        })
      },
      deep: true
    },
    flightinfo(flight) {
      if (!_.isEmpty(flight)) {
        this.dataSearchPax.flight_id = flight.id
      }
    },
    showAlertError: function () {
      let self = this
      if (self.showAlertError) {
        setTimeout(function () {
          self.messagesError = []
          self.showAlertError = false
        }, 5000)
      }
    }
  },
  beforeCreate: function () {
    this.$emit('changeLinkName', '')
  },
  created() {
    this.$store
      .dispatch('VirtualHelpdesk/checkAirlineToken', {
        airline_token: this.$route.query.token
      })
      .then((response) => {
        if (_.isEmpty(response)) {
          this.checkToken = false
        }
      })
  },
  methods: {
    updateOpenPopupSelectFlight: function (openPopup) {
      this.openPopupSelectFlight = openPopup
    },
    updateStep: function (step) {
      this.step = step
    },
    setThisIsMe(data) {
      let _pax = _.find(this.dataPax, function (pax) {
        return pax.id == data.id
      })
      let isAllPassengersHaveSamePnr = false
      if (_pax) {
        //update isAllPassengersHaveSamePnr after confirm this is me and make sure what group
        isAllPassengersHaveSamePnr = this.checkAllPaxInGroupHasSamePNR(_pax)
        _pax.isAllPassengersHaveSamePnr = isAllPassengersHaveSamePnr
        this.paxThisIsMe = _pax ? _pax : {}
      }
    },
    checkAllPaxInGroupHasSamePNR(pax) {
      const groups = pax.groups || []
      const groupPnr = _.groupBy(groups, 'pnr')
      return Object.keys(groupPnr).length === 1
    },
    updateListDataPax(dataPax) {
      this.dataPax = dataPax
    },
    updateListFlight(listFlight) {
      this.listFlight = listFlight
    },
    updateDataSearchPax(dataSearchPax) {
      this.dataSearchPax = dataSearchPax
    },
    openCameraToScan: function () {
      let self = this
      if (self.codeQrReaded.trim().length > 0) {
        self.codeQrReaded = ''
      }
      self.$bvModal.show('modal-popup-open-camera')
      if (document.getElementById('modal-popup-open-camera') && document.getElementById('reader')) {
        self.setupHtml5Qrcode()
        return
      }
      setTimeout(() => {
        self.setupHtml5Qrcode()
      }, 1000)
    },
    setupHtml5Qrcode() {
      const self = this
      const html5QrCode = new Html5Qrcode('reader')
      const config = { fps: 10, qrbox: { width: 400, height: 400 } }
      const qrCodeSuccessCallback = (decodedText, decodedResult) => {
        if (decodedResult.result) {
          self.codeQrReaded = decodedResult.decodedText || ''
          html5QrCode.stop()
          self.stopScanWhenHasCodeQr()
        }
      }
      html5QrCode.start({ facingMode: 'environment' }, config, qrCodeSuccessCallback).then(() => {
        self.cameraStatus = true
      })
      self.html5Qrcode = html5QrCode
      self.$bvModal.show('modal-popup-open-camera')
    },
    closeOrStopScanBoarding() {
      this.showAlertError = false
      if (this.cameraStatus) {
        this.html5Qrcode
          .stop()
          .then((ignore) => {
            // QR Code scanning is stopped.
            this.html5Qrcode.clear()
            this.cameraStatus = false
            this.$bvModal.hide('modal-popup-open-camera')
          })
          .catch((err) => {
            // Stop failed, handle it.
            console.log('err', err)
          })
      } else {
        this.$bvModal.hide('modal-popup-open-camera')
      }
    },
    stopScanWhenHasCodeQr() {
      this.$bvModal.hide('modal-popup-open-camera')
      if (!this.codeQrReaded) {
        console.log('scan fail')
        return
      }
      this.handleCallApiReadCodeQr()
    },
    handleCallApiReadCodeQr() {
      let self = this
      if (!_.isEmpty(self.codeQrReaded)) {
        self.$store
          .dispatch('InviteTravelTogether/cuteScanStrToPax', self.codeQrReaded)
          .then((response) => {
            if (response.success && !_.isEmpty(response.data)) {
              self.setDataSearchPax(response.data)
              self.searchListFlight()
              self.searchPassenger()
            }
          })
          .catch((err) => {
            // Stop failed, handle it.
            console.log('err', err)
          })
      }
    },
    actionEnterVitural(type) {
      this.isBeginPage = false
      switch (type) {
        case 'BOOKING_REF':
          this.type = this.TYPE_VITURAL_HELP_DESK.BOOKING_REF
          break
        case 'PASSENGER_INFO':
          this.type = this.TYPE_VITURAL_HELP_DESK.PASSENGER_DETAIL
          break
      }
      this.showPRNOrDetailSearch = true
    },
    replaceStr(string, replace, text) {
      return string.replace(replace, text)
    },
    setDataSearchPax(pax, search_type = 'FULL') {
      const default_date = this.getToDayString()
      this.dataSearchPax = {
        pnr: pax.pnr,
        first_name: pax.first_name || '',
        last_name: pax.last_name || '',
        flight_date: pax.flight_date || default_date,
        airline_id: this.airline.id,
        search_type
      }

      if (!_.isEmpty(pax.flight_number) && pax.operating_carrier_iata_code) {
        this.dataSearchPax.operating_carrier_iata_code = pax.operating_carrier_iata_code
        this.dataSearchPax.flight_number = pax.flight_number
      }

      // watch flightinfo to update dataSearchPax.flight_id
    },
    getToDayString() {
      const date = new Date()
      const year = date.getFullYear()
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const day = date.getDate().toString().padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    updateFlightInfo(flight) {
      this.flightinfo = flight
    },
    goHome() {
      window.location.reload()
    },
    pushMessagesError(message = '') {
      if (!_.isEmpty(message)) {
        this.messagesError = []
        this.messagesError.push(message)
        this.showAlertError = true
      }
    },
    async searchListFlight() {
      if (this.dataSearchPax) {
        return this.$store.dispatch('VirtualHelpdesk/searchListFlight', this.dataSearchPax).then((res) => {
          if (res.success === false) {
            if (this.dataSearchPax.search_type == 'NAME') {
              this.notFoundName = true
            } else if (this.dataSearchPax.search_type == 'PNR') {
              this.notFoundPnr = true
            }
            this.pushMessagesError('Cannot find passenger')
            return false
          } else {
            this.listFlight = res.data
            if (this.listFlight.length == 0) {
              this.pushMessagesError('Cannot find passenger')
            } else {
              if (this.listFlight.length == 1 || this.dataSearchPax.search_type == 'FULL') {
                // case scan pax
                this.flightinfo = this.listFlight[0]
                // case not scan pax, if listFlight.length == 1 -> component search watch listFlight
              } else {
                this.openPopupSelectFlight = true
              }
            }
            return true
          }
        })
      }

      return false
    },
    async searchPassenger() {
      if (this.dataSearchPax) {
        return this.$store.dispatch('VirtualHelpdesk/searchPassenger', this.dataSearchPax).then((response) => {
          if (response.success) {
            this.dataPax = response.data

            let _curPax = null
            let step = 'this_is_me'
            //if only one pax finded, we will redirect to confirm page
            if (this.dataPax.length == 1) {
              _curPax = this.dataPax[0]
              step = 'confirm'
            } else if (this.dataSearchPax.search_type === 'FULL') {
              // for search pax by scan QR code , type == full
              _curPax = this.dataPax.find(
                (_pax) =>
                  this.dataSearchPax.first_name == _pax.first_name &&
                  this.dataSearchPax.last_name == _pax.last_name &&
                  this.dataSearchPax.pnr == _pax.pnr
              )
            }
            if (_curPax) {
              // add group pax for pasenger
              let groups = _.groupBy(this.dataPax, 'group_id')
              _curPax.groups = groups[_curPax.group_id]
              _curPax.checked = true // auto select the passenger match the search
              this.paxThisIsMe = _curPax || {}
            }
            this.updateStep(step)
            return true
          } else {
            //clear message error (case user scan many times while searching have not reponse yet)
            this.pushMessagesError('Cannot find passenger')
            return false
          }
        })
      }

      return false
    }
  }
}
</script>

<style lang="scss">
.booking-reference {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.virtual-help-desk {
  input {
    background: #fafafa !important;
  }
  margin: 0.5rem;
}
.vhd-normal-row {
  height: 65px;
}
.vh-container {
  overflow-x: auto;
}
.text-120 {
  height: 120px !important;
}
.fs-scan {
  font-size: 38px;
  width: 115px;
}
.search-container {
  height: 95%;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  width: 95%;
}

.vhd-container {
  min-height: 61vh;
}
.vhd-content {
  min-height: 60vh;
}
.span-scan {
  font-weight: 500;
}
.hd-normal-btn-color .fa-camera {
  color: #fff;
}
.reference {
  line-height: 22px;
  padding: 0px 25px !important;
  max-height: 82%;
  line-height: 23px !important;
}
label[for='lastname'],
label[for='firstname'] {
  margin-bottom: 0.3rem;
}
.ws-btn:hover {
  color: #fff;
  background-color: #0069d9;
  border-color: #0062cc;
}
</style>
